// Shared site data - DISEÑO Y CONSTRUCCIÓN LUXE
import {
  Compass,
  Home,
  Factory,
  Wrench,
  HardHat,
  ShieldCheck,
  Eye,
  Layers,
  Receipt,
  Award,
  Users,
  Building2,
  Landmark,
  HousePlus,
} from "lucide-react";

export const SITE = {
  name: "DISEÑO Y CONSTRUCCIÓN LUXE",
  shortName: "LUXE",
  tagline: "Ingeniería de Precisión. Arquitectura de Lujo.",
  phone: "33 1254 6176",
  phoneRaw: "+523312546176",
  email: "contacto@dconstruccionluxe.com",
  website: "dconstruccionluxe.com",
  address: "Calle Abogados No. 638, int. 2, Jardines de Guadalupe",
  city: "Zapopan, Jalisco, México",
  cp: "C.P. 45030",
};

export const NAV_LINKS = [
  { label: "Nosotros", href: "#nosotros" },
  { label: "Servicios", href: "#servicios" },
  { label: "Atractivos", href: "#atractivos" },
  { label: "Clientes", href: "#clientes" },
  { label: "Portafolio", href: "#portafolio" },
  { label: "Contacto", href: "#contacto" },
];

export const SERVICES = [
  {
    num: "01",
    title: "Arquitectura e Ingeniería",
    description:
      "Desarrollo de proyectos ejecutivos, cálculo estructural avanzado y diseño arquitectónico integral para edificaciones de cualquier escala.",
    image:
      "https://images.pexels.com/photos/34573691/pexels-photo-34573691.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    Icon: Compass,
  },
  {
    num: "02",
    title: "Construcción de Vivienda y Comercio",
    description:
      "Edificación de residencias de lujo y complejos comerciales funcionales, cuidando cada detalle desde la cimentación hasta los acabados finales.",
    image:
      "https://images.unsplash.com/photo-1773427457869-6fbded8b89b9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBob21lJTIwY29uc3RydWN0aW9uJTIwbHV4dXJ5fGVufDB8fHx8MTc3NzY2MzM0OXww&ixlib=rb-4.1.0&q=85",
    Icon: Home,
  },
  {
    num: "03",
    title: "Infraestructura Industrial y Urbanización",
    description:
      "Ejecución de plantas industriales y proyectos de urbanización que incluyen redes hidrosanitarias, vialidades y equipamiento urbano completo.",
    image:
      "https://images.unsplash.com/photo-1771433050765-72a5eb1658ca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHw0fHxjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwZW5naW5lZXJpbmclMjBpbmR1c3RyaWFsfGVufDB8fHx8MTc3NzY2MzM0OXww&ixlib=rb-4.1.0&q=85",
    Icon: Factory,
  },
  {
    num: "04",
    title: "Instalación de Equipamientos y Acabados",
    description:
      "Colocación especializada de sistemas técnicos, climas y acabados finos que otorgan el carácter distintivo y la funcionalidad a cada obra.",
    image:
      "https://images.unsplash.com/photo-1774685110718-c5b4fe026144?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBidWlsZGluZ3xlbnwwfHx8fDE3Nzc2NjMzNDl8MA&ixlib=rb-4.1.0&q=85",
    Icon: Wrench,
  },
  {
    num: "05",
    title: "Supervisión y Gerencia de Obra",
    description:
      "Control riguroso de tiempos, presupuestos y normas de seguridad industrial para asegurar que el proyecto se cumpla conforme a lo planeado.",
    image:
      "https://images.pexels.com/photos/159306/construction-site-build-construction-work-159306.jpeg?auto=compress&cs=tinysrgb&w=940&h=650",
    Icon: HardHat,
  },
];

export const VALUES = [
  { title: "Responsabilidad Técnica", Icon: ShieldCheck },
  { title: "Transparencia en Costos", Icon: Receipt },
  { title: "Innovación Estructural", Icon: Layers },
  { title: "Compromiso con la Calidad", Icon: Award },
];

export const ATTRACTIONS = [
  {
    num: "01",
    title: "Metodología de Ingeniería de Valor",
    description:
      "Optimizamos los procesos constructivos y el uso de materiales para reducir costos innecesarios sin comprometer jamás la seguridad estructural ni la calidad estética.",
    Icon: Layers,
  },
  {
    num: "02",
    title: "Supervisión Técnica Continua",
    description:
      "Mantenemos presencia constante de ingeniería en campo, asegurando que cada etapa de la obra se ejecute estrictamente conforme al proyecto ejecutivo y las normativas vigentes.",
    Icon: Eye,
  },
  {
    num: "03",
    title: "Soluciones Integrales \"Llave en Mano\"",
    description:
      "Gestionamos desde los trámites y el diseño arquitectónico hasta la instalación del último equipamiento, liberando al cliente de la complejidad operativa que implica coordinar múltiples proveedores.",
    Icon: Wrench,
  },
  {
    num: "04",
    title: "Especialización en Acabados de Alta Gama",
    description:
      "Contamos con mano de obra certificada para la aplicación de terminados de lujo y sistemas técnicos avanzados, logrando un nivel de sofisticación superior en el mercado.",
    Icon: Award,
  },
  {
    num: "05",
    title: "Transparencia y Control Presupuestal",
    description:
      "Implementamos herramientas de gerencia de obra que permiten un seguimiento puntual de los avances y la inversión, eliminando sorpresas o costos ocultos durante la ejecución.",
    Icon: Receipt,
  },
];

export const CLIENTS = [
  {
    title: "Inversionistas y Desarrolladores",
    description:
      "Que buscan un aliado técnico para la ejecución de complejos habitacionales, plazas comerciales o fraccionamientos con altos estándares de calidad.",
    Icon: Building2,
  },
  {
    title: "Sector Industrial",
    description:
      "Empresas que requieren naves o plantas de producción diseñadas bajo requerimientos técnicos específicos y normativas de seguridad internacionales.",
    Icon: Factory,
  },
  {
    title: "Familias y Particulares",
    description:
      "Personas que desean construir la casa de sus sueños bajo un modelo de diseño personalizado y acabados de lujo \"llave en mano\".",
    Icon: HousePlus,
  },
  {
    title: "Entidades Gubernamentales e Institucionales",
    description:
      "Organismos que necesitan infraestructura de servicios, escuelas u hospitales construidos con rigor técnico y transparencia administrativa.",
    Icon: Landmark,
  },
];

export const PORTFOLIO = [
  {
    title: "Residencia Premium",
    type: "Vivienda · Acabados de Lujo",
    image:
      "https://images.unsplash.com/photo-1759369484704-fefd537878f1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBob21lJTIwY29uc3RydWN0aW9uJTIwbHV4dXJ5fGVufDB8fHx8MTc3NzY2MzM0OXww&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Complejo Comercial",
    type: "Comercio · Llave en Mano",
    image:
      "https://images.unsplash.com/photo-1765439178218-e54dcbb64bcb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBidWlsZGluZ3xlbnwwfHx8fDE3Nzc2NjMzNDl8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Estructura Industrial",
    type: "Infraestructura · Ingeniería",
    image:
      "https://images.unsplash.com/photo-1762889597634-264f0907820b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwZW5naW5lZXJpbmclMjBpbmR1c3RyaWFsfGVufDB8fHx8MTc3NzY2MzM0OXww&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Edificación Corporativa",
    type: "Comercial · Diseño Integral",
    image:
      "https://images.unsplash.com/photo-1768223933860-6d62bc5b2ff3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBidWlsZGluZ3xlbnwwfHx8fDE3Nzc2NjMzNDl8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const STATS = [
  { value: "15+", label: "Años de experiencia técnica" },
  { value: "120+", label: "Proyectos entregados" },
  { value: "100%", label: "Llave en mano" },
  { value: "ISO", label: "Estándares internacionales" },
];

export const EMAILJS_CONFIG = {
  serviceId: "service_fzugl2f",
  templateId: "template_yjoux6h",
  publicKey: "KwoBsQzTUoIh0Pizs",
};

export { Users };
